const CARD_PADDING = 8;
const COLUMN_WIDTH = 310;
const COLUMN_MARGIN = 6;

// Width of single-column card
export const singleCardWidth = COLUMN_WIDTH - CARD_PADDING * 2;

// Width of gutter between cards
const gutter = CARD_PADDING * 2 + COLUMN_MARGIN;
export const additionalCardWidth = gutter + singleCardWidth;
